import { createSlice } from "@reduxjs/toolkit";
import { getinstaCampaignList } from "./ThunkActions";
import { iInstagramCampaignState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: iInstagramCampaignState = {
  isLoading: false,
  instagramCampaignList: [],
  errorMessage: null,
};

export const instagramCampaignSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetinstagramCampaignState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getinstaCampaignList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getinstaCampaignList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.instagramCampaignList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getinstaCampaignList.rejected, (state) => {
        state.errorMessage = "Failed to fetch campaign list";
        state.isLoading = false;
      });
  },
});

export const { resetinstagramCampaignState } = instagramCampaignSlice.actions;
export default instagramCampaignSlice.reducer;
